import {
  useFreeTrialEligibilityRulesQuery,
  useFreeTrialProtectedQuery,
} from '@trello/graphql/generated';
import { getFreeTrialProperties } from '@trello/organizations';

export const useFreeTrialEligibilityRules = (
  orgId?: string,
  options: { skip: boolean } = { skip: false },
) => {
  const {
    data: dataProtected,
    loading: loadingProtected,
  } = useFreeTrialProtectedQuery(
    orgId && !options.skip
      ? {
          fetchPolicy: 'network-only',
          variables: {
            orgId: orgId,
          },
        }
      : { skip: true },
  );

  const meId = dataProtected?.member?.id;

  const isMember = dataProtected?.organization?.memberships.find(
    (member) => member.idMember === meId,
  );

  const { data, loading } = useFreeTrialEligibilityRulesQuery(
    orgId && isMember && !options.skip
      ? {
          fetchPolicy: 'network-only',
          variables: {
            orgId: orgId,
          },
        }
      : { skip: true },
  );

  const credits = data?.organization?.credits || [];
  const products = data?.organization?.products || [];
  const trialProperties = getFreeTrialProperties(credits, products);

  const isAdmin =
    meId &&
    !!data?.organization?.memberships.find(
      (member) => member.idMember === meId && member.memberType === 'admin',
    );

  return {
    isAdmin,
    hasCredit: !!trialProperties?.credit,
    isTrialActive: trialProperties?.isActive,
    isExpired: trialProperties?.isExpired,
    isEligible: isAdmin && !trialProperties?.credit,
    loading: loading || loadingProtected,
    daysLeft: trialProperties?.daysLeft || 0,
    trialSource: trialProperties?.trialSource,
    startDate: trialProperties?.startDate,
    days: trialProperties?.days,
  };
};
